import React from 'react';
import PropTypes from 'prop-types';
import { useBigScreen, useTranslation } from 'hooks';
import { Container } from 'components/styledComponents';
import TopRightMenu from './TopRightMenu';
import Logo from './Logo';
import { Header, LinkContainer, StyledNavLink } from './style';

function AppHeader({ className }) {
  const { t } = useTranslation();
  return (
    <Container as={Header} className={className}>
      <Logo />
      {useBigScreen() && (
        <LinkContainer>
          <StyledNavLink to="/dashboard">{t('link.home')}</StyledNavLink>
          <StyledNavLink to="/resume">{t('link.resume')}</StyledNavLink>
          <StyledNavLink to="/management">{t('link.opportunitiesPlacements')}</StyledNavLink>
        </LinkContainer>
      )}
      <TopRightMenu />
    </Container>
  );
}

AppHeader.propTypes = {
  className: PropTypes.string
};

export default AppHeader;
